<template>
    <a-layout>
      <a-layout-header class="userheader-wrap" :style="{
        width: '100%',
        height: '64px',
        background: '#f1c331 !important',
      }">
        <Header />
      </a-layout-header>
      <a-layout>
        <a-layout-sider class="usersider-wrap" :style="{
          background: 'white !important',
        }">
          <Sider />
        </a-layout-sider>
        <a-layout-content :style="{
          background: 'white !important',
        }">
          <router-view :key="$route.path"></router-view>
        </a-layout-content>
      </a-layout>
    </a-layout>
</template>

<script>
import Header from '../../components/user-header'
import Sider from '../../components/user-sider'
export default {
  components: {
    Header,
    Sider,
  },
}
</script>

<style lang="less">
@media screen and (max-width: 1000px) {
  *>.usersider-wrap {
    display: none;
  }

  *>.userheader-wrap {
    padding: 0 10px;
  }
}
</style>